"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingHelper = void 0;
var ShippingHelper = /** @class */ (function () {
    function ShippingHelper() {
    }
    ShippingHelper.productGroupCanBeShiftedToAfterChristmas = function (productGroup) {
        return [
            'AB',
            'AC',
            'B1',
            'B3',
            'B4',
            'B5',
            'B6',
            'B7',
            'B8',
            'B9',
            'BD',
            'BE',
            'BM',
            'BT',
            'RB',
            'RC',
            'AT',
            'FT',
            'RT',
            'TC',
            'TM',
            'TT',
            'DT',
            'KD',
            'AP',
            'PE',
            'RP',
            'CD',
            'AK',
            'KE',
            'KM',
            'RK',
            'BK',
            'CE',
            'CL',
            'CT',
            'GI',
            'GT',
            'AJ',
            'RJ',
            'SI',
            'ST',
            'GS',
            'AS',
            'SD',
            'SE',
            'AM',
            'RM',
            'UK',
            'JE',
            'VL',
            'O4',
            'OL',
            'FE',
            'GG',
            'GZ',
            'KS',
            'AB',
            'B1',
            'B3',
            'B4',
            'B5',
            'B6',
            'BD',
            'BF',
            'FT',
            'TF',
            'TG',
            'TM',
            'TR',
            'OE',
            'OF',
            'XE',
            'XF',
            'GI',
            'BK',
            'NE',
            'DT',
            'GF',
        ].includes(productGroup);
    };
    return ShippingHelper;
}());
exports.ShippingHelper = ShippingHelper;
